export class NFTModule {
}
